import Vue from 'vue';
import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';

// mutations declarations
export const SET_ALERTS = 'SET_ALERTS';
export const SET_ALERT_DATA = 'SET_ALERT_DATA';
export const SET_UNREAD_STATS = 'SET_UNREAD_STATS';
export const SET_PULLING_INTERVAL = 'SET_PULLING_INTERVAL';
export const SET_HIDE_ALERTS_BAR_FLAG = 'SET_HIDE_ALERTS_BAR_FLAG';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_ALERTS](state, payload) {
		Vue.set(state, 'alerts', payload);
	},
	[SET_UNREAD_STATS](state, unread) {
		Vue.set(state, 'unread', unread);
	},
	[SET_ALERT_DATA](state, payload) {
		const { key, value } = payload;
		Vue.set(state.alerts, key, value);
	},
	[SET_PULLING_INTERVAL](state, payload) {
		const interval = payload?.interval;
		Vue.set(state, 'pullingInterval', interval);
	},
	[SET_HIDE_ALERTS_BAR_FLAG](state, payload) {
		const { value } = payload;
		Vue.set(state, 'hideAlertsBar', value);
	},
};

export default mutations;
